'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { Icon, type IconSvgElement } from '@/components/ui/icon';
import { ChampionIconSolid, EightCircleIconSolid, FiveCircleIconSolid, FourCircleIconSolid, MoreHorizontalIcon, NineCircleIconSolid, OneCircleIconSolid, SevenCircleIconSolid, SixCircleIconSolid, ThreeCircleIconSolid, TwoCircleIconSolid } from '@/components/ui/icon/glyphs';
import { Link } from '@/i18n/navigation';
import { useFormattedCurrency } from '@/lib/currency';
const COUNT_ICONS: Readonly<Record<number, IconSvgElement>> = {
  1: OneCircleIconSolid,
  2: TwoCircleIconSolid,
  3: ThreeCircleIconSolid,
  4: FourCircleIconSolid,
  5: FiveCircleIconSolid,
  6: SixCircleIconSolid,
  7: SevenCircleIconSolid,
  8: EightCircleIconSolid,
  9: NineCircleIconSolid
};
export function StackedMarketCardFooter(t0) {
  const $ = _c(38);
  const {
    pubkey,
    outcomeCount,
    prizePool,
    threshold,
    bookmark,
    linkDisabled: t1,
    onOpenMarket
  } = t0;
  const linkDisabled = t1 === undefined ? false : t1;
  const t = useTranslations("market.row");
  const {
    formatD6
  } = useFormattedCurrency();
  const hiddenCount = Math.max(0, outcomeCount - 2);
  const t2 = COUNT_ICONS[hiddenCount] ?? MoreHorizontalIcon;
  let t3;
  if ($[0] !== t2) {
    t3 = <Icon icon={t2} className="size-icon-sm" aria-hidden="true" />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = hiddenCount > 9 ? `${String(hiddenCount)} ` : "";
  let t5;
  if ($[2] !== t) {
    t5 = t("more");
    $[2] = t;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t4 || $[5] !== t5) {
    t6 = <span>{t4}{t5}</span>;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t3 || $[8] !== t6) {
    t7 = <>{t3}{t6}</>;
    $[7] = t3;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const more = t7;
  let t8;
  if ($[10] !== hiddenCount || $[11] !== linkDisabled || $[12] !== more || $[13] !== onOpenMarket || $[14] !== pubkey || $[15] !== t) {
    t8 = hiddenCount > 0 ? <>{onOpenMarket !== undefined ? <AnimatedButton variant="tertiary" size="xs" className="pointer-events-auto h-auto gap-1 p-0 text-caption text-foreground-tertiary hover:bg-transparent" disableHoverScale={true} aria-label={t("moreOutcomes", {
        count: hiddenCount
      })} onClick={onOpenMarket}>{more}</AnimatedButton> : linkDisabled ? <span role="img" className="inline-flex items-center gap-1" aria-label={t("moreOutcomes", {
        count: hiddenCount
      })}>{more}</span> : <Link href={`/markets/${pubkey}`} prefetch={false} className="pointer-events-auto inline-flex items-center gap-1" aria-label={t("moreOutcomes", {
        count: hiddenCount
      })}>{more}</Link>}<span aria-hidden="true">·</span></> : null;
    $[10] = hiddenCount;
    $[11] = linkDisabled;
    $[12] = more;
    $[13] = onOpenMarket;
    $[14] = pubkey;
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span aria-hidden="true">·</span>;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Icon icon={ChampionIconSolid} className="size-icon-xs" aria-hidden="true" />;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t) {
    t11 = t("prizePoolLabel");
    $[19] = t;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11) {
    t12 = <span className="sr-only">{t11}</span>;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== formatD6 || $[24] !== prizePool) {
    t13 = formatD6(prizePool, "compactDecimal");
    $[23] = formatD6;
    $[24] = prizePool;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13) {
    t14 = <span className="truncate">{t13}</span>;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t12 || $[29] !== t14) {
    t15 = <span className="inline-flex min-w-0 items-center gap-1">{t10}{t12}{t14}</span>;
    $[28] = t12;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== bookmark) {
    t16 = <span className="pointer-events-auto ml-auto shrink-0">{bookmark}</span>;
    $[31] = bookmark;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t15 || $[34] !== t16 || $[35] !== t8 || $[36] !== threshold) {
    t17 = <div className="pointer-events-none relative z-10 flex items-center gap-2 text-caption text-foreground-tertiary" data-testid="stacked-market-card-footer">{t8}{threshold}{t9}{t15}{t16}</div>;
    $[33] = t15;
    $[34] = t16;
    $[35] = t8;
    $[36] = threshold;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  return t17;
}